<template>
  <v-toolbar color="white" flat app :tabs="tabs ? true : false">
    <v-avatar size="32px" tile v-if="$route.path === '/' || $route.path === '/metrics'">
      <img src="../../assets/element-iot-icon-h300.png" />
    </v-avatar>
    <v-btn :to="backUrl" flat icon v-else>
      <v-icon>arrow_back</v-icon>
    </v-btn>

    <v-toolbar-title v-if="$route.path === '/' || $route.path === '/metrics'">
      Smart Parking <span class="c beta">BETA</span>
    </v-toolbar-title>
    <v-toolbar-title v-else>
      <span>{{ navTitle }}</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn
      v-for="element in rightElements"
      :key="element.label"
      :flat="element.flat"
      :icon="element.icon.show"
      :to="element.to"
      :color="element.color">
      <v-icon v-if="element.icon.name">{{ element.icon.name }}</v-icon>
      <span>{{ element.label }}</span>
    </v-btn>
    <v-tabs slot="extension" v-if="tabs" slider-color="primary">
      <v-tab v-for="tab in tabs" :key="tab.label" :to="tab.to">
        {{ tab.label }}
      </v-tab>
    </v-tabs>
  </v-toolbar>
</template>

<script>
export default {
  name: 'navigation',

  computed: {
    navTitle() {
      return this.$store.navigation.state.navigation.title;
    },
    lastUrl() {
      return this.$store.app.state.last_url;
    },
    backUrl() {
      return this.$store.navigation.state.navigation.backUrl;
    },
    rightElements() {
      return this.$store.navigation.state.navigation.rightElements;
    },
    tabs() {
      return this.$store.navigation.state.navigation.tabs;
    },
  },
};
</script>
